/**
 * Dev-only accessibility audit — runs `@axe-core/react` against the live tree
 * so violations surface in the browser console as soon as a route renders.
 *
 * Production builds skip this entirely (Vite tree-shakes the dynamic import).
 */
export async function initAxe(): Promise<void> {
  if (!import.meta.env.DEV) return;
  if (typeof window === 'undefined') return;
  try {
    const [React, ReactDOM, axe] = await Promise.all([
      import('react'),
      import('react-dom'),
      import('@axe-core/react'),
    ]);
    axe.default(React.default, ReactDOM.default, 1000, {
      rules: [
        { id: 'color-contrast', enabled: true },
        { id: 'region', enabled: false },
      ],
    } as Record<string, unknown>);
  } catch {
    // Best-effort — never block app boot on the audit.
  }
}
